export function isOneOf(value, array) {
    return typeof value !== 'undefined' && array.indexOf(value) !== -1;
}
